module.exports = __webpack_public_path__ + "static/media/ic_aeps_report.89e40124.png";